import ParticipantsService from 'services/ParticipantsService';

import useResources from 'hooks/useResources';

import { type Participant } from 'types/zod/participant';

interface ParticipantInfoBlockProps {
    participant: Participant;
}

const ParticipantInfoBlock = (props: ParticipantInfoBlockProps) => {
    const { participant } = props;
    const { t } = useResources();

    return (
        <>
            {ParticipantsService.isAddressVisible(participant) && (
                <div>
                    <div>{t(`customizeNotificationsPopUp.participantsInfoAddress`)}</div>
                    <div className="d-flex flex-column align-items-start">
                        <div>{participant?.address?.domicile?.address_line1}</div>
                        <div>
                            {participant?.address?.domicile?.city ? participant?.address?.domicile?.city + `, ` : ``}
                            {participant?.address?.domicile?.state_name
                                ? participant?.address?.domicile?.state_name + ` `
                                : ` `}
                            {participant?.address?.domicile?.region
                                ? participant?.address?.domicile?.region + ` `
                                : ` `}
                        </div>
                        <div>{participant?.address?.domicile?.zip ? participant?.address?.domicile?.zip : ``}</div>
                        <div>
                            {participant?.address?.domicile?.country_name
                                ? participant?.address?.domicile?.country_name
                                : ``}
                        </div>
                    </div>
                </div>
            )}
            {participant.email && (
                <div>
                    <div>{t(`customizeNotificationsPopUp.participantsInfoEmail`)}</div>
                    <div>
                        <div>{participant?.email}</div>
                    </div>
                </div>
            )}
            {participant.phone_number && (
                <div>
                    <div>{t(`customizeNotificationsPopUp.participantsInfoPhone`)}</div>
                    <div>
                        <div>{ParticipantsService.formatPhone(participant.phone_number)}</div>
                    </div>
                </div>
            )}
        </>
    );
};

export default ParticipantInfoBlock;
